import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from 'next-seo';
import RoundedButton from 'components/RoundedButton';
import Separator from 'components/Separator';
import { getCta } from 'utils/common';

const Article = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/daymade-x-much-better-adventures`;

  return (
    <MainLayout>
      <NextSeo
        title="Positive Impact Partnership With MBA | Win Epic Prizes | DAYMADE"
        description="Exciting news alert! We’ve partnered up with our pals at Much Better Adventures to bring you even more amazing trips and getaways from Cornwall to Colombia."
        openGraph={{
          title:
            'Positive Impact Partnership With MBA | Win Epic Prizes | DAYMADE',
          description:
            'Exciting news alert! We’ve partnered up with our pals at Much Better Adventures to bring you even more amazing trips and getaways from Cornwall to Colombia.',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/daymade-x-much-better-adventures',
          images: [
            {
              url: `${IMAGE_DIRECTORY}/hero.jpg`,
              alt: 'Martian Dome hotel in desert in Jordan',
            },
          ],
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'win a holiday,win a trip,win a prize,sustainable tourism,eco tourism,jungle expedition,Colombia,arctic circle,Norway,Jordan,martian dome,Everest,Kathmandu,Romania,Carpathian mountains,wild bears,Greenland,kayak trip,kayak holiday,plant a tree',
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText="Martian Dome hotel in desert in Jordan"
        heroImageYPosition="48%"
      >
        <>
          <h1 style={{ fontSize: '1.6em', lineHeight: '1.4em' }}>
            Our Positive-Impact Partnership with{' '}
            <strong>Much Better Adventures</strong>
          </h1>

          <p className="subheading">
            We’ve joined forces to bring you even more amazing trips and
            getaways
          </p>

          <div
            className="separator"
            style={{ width: '80%', marginTop: 0 }}
          />

          <p
            style={{
              fontStyle: 'italic',
              textAlign: 'center',
              marginBottom: '2em',
            }}
          >
            by Abbi James
          </p>

          <p>
            <span className="bigFirstLetter">E</span>xciting news alert! We’ve
            partnered up with our pals at Much Better Adventures to bring you
            even more amazing trips and getaways from Cornwall to Colombia.
          </p>

          <p>
            It’s no secret that DAYMADE is run by a travel-loving bunch, and the
            same can be said for Much Better Adventures. They’re always on the
            lookout to uncover amazing outdoor experiences all across the globe.
            To put it in their own words: Go Places Others Won’t. By working
            with local guides, they not only support local businesses, but also
            provide unique, intimate travel experiences. Read on to find out
            more about Much Better Adventures and which of their epic trips you
            can win with DAYMADE!
          </p>

          <p>Much Better Adventures are on a mission:</p>

          <p style={{ textAlign: 'center', fontWeight: 800 }}>
            TO PROTECT THE WORLD’S WILD PLACES, ONE ADVENTURE AT A TIME.
          </p>

          <p>
            Their goal to create the world’s most positive-impact adventure
            company is one we 1000% support. Much Better Adventures are taking a
            variety of steps to action this, from reducing their carbon
            footprint to backing vital conservation work.
          </p>

          <p>
            DAYMADE and Much Better Adventures are both committed to planting
            trees to reduce our carbon footprints. Here at DAYMADE, we’re
            dedicated to planting a tree for every purchase, with 178,000+ trees
            having been planted so far. Our like-minded friends at Much Better
            Adventures pledge to plant enough trees to suck 2x as much carbon
            back out of the atmosphere as the amount produced for each trip.
            They also donate 5% of revenue to support conservation,
            reforestation and rewilding projects.
          </p>

          <p>
            Much Better Adventures work with 100% locally owned, independent
            businesses. The impact of this is that an average of{' '}
            <strong>80% of money spent stays in the local economy</strong> –
            compared to a shockingly-low 5% from mass tourism. By investing in
            local communities and helping to build sustainable economies in
            rural areas, Much Better Adventures further supports local nature
            conservation efforts.
          </p>

          <h4>Sustainable tourism can empower local communities</h4>

          <p>
            It’s high time tourism models stopped exploitation and started to
            focus on how they will benefit the local community. That’s exactly
            what Much Better Adventures do – they work to empower local
            communities in every trip they provide. For instance, by working
            with the social enterprise Eternal Landscapes, they are supporting
            local women in Mongolia to become local tour guides to build
            financial independence, unique skills and a sense of empowerment.
            This, in turn, leads to greater possibilities in conserving natural
            landscapes. This is just one example of how they’ve empowered local
            communities worldwide.
          </p>

          <p>
            Now that you know why we’re so excited to partner with this great
            team, let’s give you the run-down on our top six trips by Much
            Better Adventures!
          </p>

          <h4>Jungle Expedition into the Heart of Colombia</h4>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt="4 hikers with backpacks stood at the top of a mountain with another mountain in the distance"
            className="singleBlogImage"
          />

          <p>
            Much Better Adventures have really done their name proud with this
            one. You and five fellow adventurers will hop on over to Colombia,
            where you’ll trek through untouched tropical rainforest. You’ll be
            one of the first explorers to set foot in a totally remote corner of
            Colombia. You’ll find yourself hiking through the valley of the Rio
            Verde of Los Henados, learning about the abundance of plants
            traditionally used in local culture and medicine. As you navigate
            your way through the pristine rainforest, you could encounter
            spectacular wildlife from tigrillos to tapirs! You’ll then find
            yourself exploring the jungle from a different angle, as you raft
            through Colombia’s rivers through the Grand Gorge.
          </p>

          <p>
            Your local guides are experts in their field, brimming with
            knowledge on the local flora and fauna. They’re the bees-knees when
            it comes to knowing where to go, what to do and how to stay safe.
            With everything planned for you, all you’ll have to decide is who to
            bring with you on your jungle expedition!
          </p>

          <h4>Ultimate Arctic Circle Adventure in Norway</h4>

          <img
            src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
            alt="Inside of a canvas snow dome hotel room in Norway with snow outside the panes of glass"
            className="singleBlogImage"
          />

          <p>
            This trip is perfect for the solo traveller looking to join a group
            of like-minded adventurers. Once you touch down in Norway, you’ll
            dive straight into the stunning Arctic landscape. Nestle down into
            your Aurora Canvas Dome, which will be your base for three cosy
            nights under the Northern Lights. You’ll spend your days mushing
            with Alaskan Huskies, snowshoeing through peaceful pine forests and
            hopping on snowmobiles for a glide across one of Europe’s last
            wildernesses. Your evenings will be filled with chasing the Northern
            Lights on fat bikes, dipping into traditional Nordic saunas and
            enjoying local delicacies. Keep your eyes peeled for a sight of
            reindeer, even more of a spectacle under the light of the aurora!
          </p>

          <h4>Explore Jordan and Sleep in a Martian Dome</h4>

          <img
            src={`${IMAGE_DIRECTORY}/hero.jpg`}
            alt="Martian Dome hotel in desert in Jordan"
            className="singleBlogImage"
          />

          <p>
            It’s time to grab your plus one and embark on your ultimate Jordan
            adventure. No trip to the Dead Sea is complete without experiencing
            a float in the salty water, so of course that’s high on our priority
            list! You’ll also explore the Dana Biosphere Nature Reserve, home to
            breathtaking mountains and a huge variety of wildlife. The next stop
            on your adventure will be to hike across the desert before soaking
            up the history of ancient Petra. Step into desert scenes made famous
            by The Martian and Star Wars, before bunkering down in your Martian
            Dome to watch the Milky Way. Before leaving Jordan, you’ll be
            treated to views across Egypt and Saudi Arabia – just don’t blame us
            if this ignites even more wanderlust!
          </p>

          <h4>Trek to Everest Base Camp</h4>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt="Group of people hiking up snowy mountain-face in a line"
            className="singleBlogImage"
          />

          <p>
            Everest has long-been the go-to destination for explorers near and
            far, but Much Better Adventures have stayed true to their name by
            offering a unique experience. Starting in Kathmandu, your journey
            will see you hiking undulating trails, crossing suspension bridges
            and navigating glaciers on your quest to explore Everest. Your hikes
            will be through rhododendron forests, past summer yak pastures and
            tributary valleys, stopping of course at stunning monasteries along
            the way. As you can imagine this trip is physically demanding, but
            it’s unmistakably worth it! You’ll be rewarded with stunning vistas
            as you challenge yourself on this trip of a lifetime.
          </p>

          <h4>Bear Watching and Castle Hopping in Romania</h4>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt="Large Brown Bear on top of rock in forest"
            className="singleBlogImage"
          />

          <p>
            If you don’t have quite as much time on your hands, but you still
            want your dose of wildlife, history and culture, this one’s for you.
            You’ll delve into Bucharest’s vibrant culture, before making your
            way to the Carpathian Mountains through scenic Transylvanian
            countryside. Immerse yourself in a fairy tale as you visit Bran
            Castle, better known as Dracula’s Castle, and Peles Castle. In the
            mountains, you’ll watch wild bears from the comfort of an elevated
            treehouse – just don’t forget to send us a photo!
          </p>

          <h4>Self-Powered 100km Adventure in Greenland</h4>

          <img
            src={`${IMAGE_DIRECTORY}/secondary5.jpg`}
            alt="Solo-kayak in still water with ice cap in background"
            className="singleBlogImage"
          />

          <p>
            This last one’s been named as one of the “Top Life-Changing
            Adventures” by <i>The Telegraph</i> – perfect for the intrepid
            explorers and go-getters! You’ll find yourself discovering
            Greenland’s unspoilt wilderness by water and on foot. Hike over
            glaciers and trek to Tasersuatsiaq Lake to watch caribou feeding on
            salts from the fjords. Climb into your kayak and paddle your way
            through dramatic fjords and across icebergs, keeping your eyes
            peeled for whales and seals. Depending on when you decide to go, you
            might also be treated to seeing the Northern Lights!
          </p>

          <Separator style={{ margin: '2em' }} />

          <p>
            We’re big fans of Much Better Adventures for a whole host of
            reasons. We have huge respect for their aspiration to be the world’s
            most positive-impact adventure company. Their work creates
            incredible experiences for both adventurers and local communities
            too. They were also the first international travel company to
            publish carbon labels for all their trips, encouraging the rest of
            the industry to follow suit by making their methodology freely
            available. All of this in addition to having some pretty epic trips
            means we think they’re worth shouting about.
          </p>

          <p>
            The only question is, if you win big, what trip would you go for?
            Enter today and see where luck will take you!
          </p>

          <RoundedButton
            href={getCta()?.url}
            style={{ minWidth: '180px' }}
          >
            Enter Now
          </RoundedButton>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default Article;
